import React from 'react';
import Link from 'next/link';
import { Anchor } from '@components/shared/styles';
import { ColumnAnchor } from './ResultsTableRow';

export const NavigationLink = ({
  children,
  albumUri,
  renderAsFlexColumn,
  justifyCenter = false,
}: {
  children: React.ReactNode;
  albumUri: string;
  renderAsFlexColumn?: boolean;
  justifyCenter?: boolean;
}) => {
  if (renderAsFlexColumn) {
    return (
      <Link tabIndex={0} href={`/release/${albumUri}`} passHref legacyBehavior>
        <ColumnAnchor justifyCenter={justifyCenter}>{children}</ColumnAnchor>
      </Link>
    );
  }

  return (
    <Link tabIndex={0} href={`/release/${albumUri}`} passHref legacyBehavior>
      <Anchor>{children}</Anchor>
    </Link>
  );
};
